import React, { useState } from "react";
import { Box, Button, Checkbox, FormControl, FormControlLabel, Grid, Typography } from "@mui/material";
import { CustomFormControl } from "../../../components/FormControl";
import { validateIntegerOrEmpty } from "../../../utils/validation";

export default function StaffStockSearchForm({searchCondition, search}) {

  /** 項目エラーメッセージを保持するState */
  const [errorMessages, setErrorMessages] = useState({
    staffId: [],
    salesRecordNo: []
  })

  /** 検索ボタン押下時 */
  const onClickSearch = (event) => {
    search();
  };

  /** 入力変更時の項目変更 */
  const changePropValue = (propName) => (v) => {
    searchCondition.update(propName, v);
    
    /** バリデーション実行 */
    if (propName in searchFormValidations) {
      setErrorMessages((prev) => ({
        ...prev,
        [propName] : searchFormValidations[propName]
          .map((validationFunc) => validationFunc(v))
          .filter((msg) => msg.length > 0)
      }))
    }    
  }

  return (
    <Box border="1px solid blue" borderRadius={1} padding={2}>
      <SearchButton
        onClick={onClickSearch}
        disabled={Object.values(errorMessages).some((msgs) => msgs.length > 0)}
      />
      <Box margin={2} marginBottom={1}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs="auto">
            <IntegerFormControl
              label="担当者ID : "
              value={searchCondition.Value.staffId}
              setValue={changePropValue("staffId")}
              errorMessages={errorMessages.staffId}
            />
          </Grid>
          <Grid item xs="auto">
            <TextFormControl
              label="荷主 : "
              value={searchCondition.Value.commodityOwner}
              setValue={changePropValue("commodityOwner")}
            />
          </Grid>
          <Grid item xs="auto">
            <TextFormControl
              label="商品 : "
              value={searchCondition.Value.product}
              setValue={changePropValue("product")}
            />
          </Grid>
          <Grid item xs="auto">
            <IntegerFormControl
              label="販売原票No : "
              value={searchCondition.Value.salesRecordNo}
              setValue={changePropValue("salesRecordNo")}
              errorMessages={errorMessages.salesRecordNo}
            />
          </Grid>
        </Grid>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs="auto">
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={searchCondition.Value.includesNotAvailableStock}
                    onChange={(e) => changePropValue("includesNotAvailableStock")(e.target.checked)}
                  />
                }
                label="非表示原票を含む"
              />
            </FormControl>
          </Grid>
          <Grid item xs="auto">
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={searchCondition.Value.includesOnlyChangedToday}
                    onChange={(e) => changePropValue("includesOnlyChangedToday")(e.target.checked)}
                  />
                }
                label="当日在庫変動分に絞る"
              />
            </FormControl>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

/** 検索ボタン */
const SearchButton = ({onClick, disabled}) => (
  <Button variant="contained" onClick={onClick} disabled={disabled} sx={{ marginLeft: 2 }}>
    検索
  </Button>
);

/** テキストボックスのフォーム */
const TextFormControl = ({label, value, setValue}) => (

    <Grid container spacing={1} alignItems="center">
      <Grid item xs='auto' mb={1}>
          <Typography>{label}</Typography>
      </Grid>
      <Grid item xs='auto'>
        <CustomFormControl
          value={value}
          setValue={setValue}
          inputProps={{width: "45mm"}}
          helperTextSx={{height:"2mm"}}
        />
      </Grid>
    </Grid>
);

/** 数値ボックスのフォーム */
const IntegerFormControl = ({label, value, setValue, errorMessages}) => (

  <Grid container spacing={1} alignItems="center">
    <Grid item xs='auto' mb={1}>
        <Typography>{label}</Typography>
    </Grid>
    <Grid item xs='auto'>
      <CustomFormControl
        value={value}
        setValue={setValue}
        inputProps={{width: "45mm"}}
        error={errorMessages.length > 0}
        helperText={errorMessages[0]}
        helperTextSx={{height: "2mm"}}
      />
    </Grid>
  </Grid>
);

const searchFormValidations = {
  staffId: [
    (v) => !validateIntegerOrEmpty(v) ? "数値を入力してください" : ''
  ],
  salesRecordNo: [
    (v) => !validateIntegerOrEmpty(v) ? "数値を入力してください" : ''
  ]
}
